import { apiClient } from '../../lib/api-client';
import { PATIENT_UHID_SEARCH_LIMIT } from '../../lib/patient-uhid-search';
import type {
  CreateDialysisAdmissionPayload,
  DialysisAdmission,
  DialysisListFilters,
  DialysisLookupOption,
  DialysisPrescription,
  Pagination,
  UpdateDialysisAdmissionPayload,
  UpsertDialysisPrescriptionPayload,
} from './types';

interface ApiResponse<T> { success: true; data: T }
interface PaginatedResponse<T> extends ApiResponse<T[]> { pagination: Pagination }

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchDialysisAdmissions = async (filters: DialysisListFilters) => {
  const response = await apiClient.get<PaginatedResponse<DialysisAdmission>>('/dialysis/admissions', { params: compactParams(filters) });
  return response.data;
};

export const fetchDialysisAdmission = async (id: string) => {
  const response = await apiClient.get<ApiResponse<DialysisAdmission>>(`/dialysis/admissions/${id}`);
  return response.data.data;
};

export const createDialysisAdmission = async (payload: CreateDialysisAdmissionPayload) => {
  const response = await apiClient.post<ApiResponse<DialysisAdmission>>('/dialysis/admissions', payload);
  return response.data.data;
};

export const updateDialysisAdmission = async (id: string, payload: UpdateDialysisAdmissionPayload) => {
  const response = await apiClient.patch<ApiResponse<DialysisAdmission>>(`/dialysis/admissions/${id}`, payload);
  return response.data.data;
};

export const fetchDialysisPrescription = async (admissionId: string) => {
  const response = await apiClient.get<ApiResponse<DialysisPrescription>>(`/dialysis/admissions/${admissionId}/prescription`);
  return response.data.data;
};

export const saveDialysisPrescription = async (admissionId: string, payload: UpsertDialysisPrescriptionPayload) => {
  const response = await apiClient.put<ApiResponse<DialysisPrescription>>(`/dialysis/admissions/${admissionId}/prescription`, payload);
  return response.data.data;
};

export const fetchDialysisLookups = async (type: string, search = '', extra: { state?: string; ward?: string } = {}) => {
  const response = await apiClient.get<ApiResponse<DialysisLookupOption[]>>('/dialysis/lookups', { params: compactParams({ type, search, ...extra, limit: type === 'patients' ? PATIENT_UHID_SEARCH_LIMIT : 500 }) });
  return response.data.data;
};
